import { DEFAULT_LIST_PAGE_SIZE } from '#/utils/listUrl/listPaginationDefaults';

function snakeToCamel(key) {
  return key.replace(/_([a-z])/g, (_, char) => char.toUpperCase());
}

function camelToSnake(key) {
  return key.replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
}

export function keysToCamel(value) {
  if (Array.isArray(value)) {
    return value.map(keysToCamel);
  }
  if (value !== null && typeof value === 'object') {
    return Object.entries(value).reduce((acc, [key, nested]) => {
      acc[snakeToCamel(key)] = keysToCamel(nested);
      return acc;
    }, {});
  }
  return value;
}

export function wirePageToCamel(page = {}) {
  return keysToCamel(page);
}

/**
 * Ver4 list page → Tier1 table 契約（snake_case）。
 * 接受後端 snake 或 wirePageToCamel 後的 camel。
 * Ver4 live 別名：number／page、size／page_size、total_items、total_pages（見 SP-06j-b、SRM supplier）。
 */
export function normalizeListPage(page = {}, fallbackPageSize = DEFAULT_LIST_PAGE_SIZE) {
  const camelPage = wirePageToCamel(page);
  const totalCount = Number(
    camelPage.totalCount
      ?? camelPage.totalItems
      ?? camelPage.totalElements
      ?? 0,
  ) || 0;
  const pageSize = Number(
    camelPage.pageSize ?? camelPage.size ?? fallbackPageSize,
  ) || fallbackPageSize;
  let totalPage = Number(camelPage.totalPage ?? camelPage.totalPages ?? 0);

  if (totalPage < 1) {
    totalPage = Math.max(1, Math.ceil(totalCount / pageSize));
  }

  const currentPage = Math.min(
    Math.max(
      1,
      Number(camelPage.currentPage ?? camelPage.number ?? camelPage.page ?? 1) || 1,
    ),
    totalPage,
  );

  return {
    current_page: currentPage,
    page_size: pageSize,
    total_count: totalCount,
    total_page: totalPage,
  };
}

export function keysToSnake(value) {
  if (Array.isArray(value)) {
    return value.map(keysToSnake);
  }

  if (value !== null && typeof value === 'object') {
    return Object.entries(value).reduce((acc, [key, nested]) => {
      acc[camelToSnake(key)] = keysToSnake(nested);
      return acc;
    }, {});
  }

  return value;
}
